import { WC_API_URL,WC_API_HEADER_KEY } from "../../../config/config"
import axios from "axios"

export const LoginAPI = async (type,data) => {
  console.log(type,data);
   try {
     let res=''
     if(type==='wcPartner'){
       res = await axios.get(`${WC_API_URL}/partners/byemail?email=${data.email}`,
         {
            headers:{
               'x-internal-key' : WC_API_HEADER_KEY
            }
         }
       )
     }
     else{
       res = await axios.post(`${WC_API_URL}/referralPartners/login`,
         data,
         {
            headers:{
               'x-internal-key' : WC_API_HEADER_KEY
            }
         }
      )
     }
    
     return {success:true,res}
   } catch (error) {
      return {
            success:false,
            message:error?.response?.data?.message,
            error
        }
   }
}
